<main>

<app-header></app-header>
<router-outlet (activate)="changeOfRoutes()"></router-outlet>
</main>
<app-footer></app-footer>